export default "__VITE_ASSET__CpDpsmDt__"